var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutEverywhere(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-out-everywhere_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sign-out-everywhere_svg__ds",
    x1: 216.98,
    y1: 215.51,
    x2: 370.75,
    y2: 215.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m262.92,388.09c7.16,0,12.99-5.82,13-12.98,0-3.47-1.34-6.74-3.79-9.2-2.45-2.46-5.72-3.82-9.19-3.82l-43.05-.06c-14.9-.02-27.02-12.16-27.02-27.05V94.86c0-7.2,2.81-13.97,7.91-19.06,5.09-5.08,11.85-7.88,19.07-7.88l44.75.07c7.16,0,12.99-5.82,13-12.98.01-7.17-5.81-13.01-12.98-13.02l-44.81-.07c-14.12,0-27.41,5.5-37.4,15.48-10.02,10-15.54,23.31-15.54,37.46v240.12c0,29.21,23.77,53.01,52.98,53.05l43.06.06Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93,354.28c-5.01-4.91-8.13-11.75-8.13-19.3V94.86c0-7.2,2.81-13.97,7.91-19.06,5.09-5.08,11.85-7.88,19.07-7.88l44.75.07c7.16,0,12.99-5.82,13-12.98.01-7.17-5.81-13.01-12.98-13.02l-44.81-.07c-14.12,0-27.41,5.5-37.4,15.48-10.02,10-15.54,23.31-15.54,37.46v240.12c0,22.57,14.2,41.9,34.13,49.55v-30.25Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149,356.06c-6.17-4.96-10.13-12.57-10.13-21.08V94.86c0-7.2,2.81-13.97,7.91-19.06,5.09-5.08,11.85-7.88,19.07-7.88l44.75.07c7.16,0,12.99-5.82,13-12.98.01-7.17-5.81-13.01-12.98-13.02l-44.81-.07c-14.12,0-27.41,5.5-37.4,15.48-10.02,10-15.54,23.31-15.54,37.46v240.12c0,23.32,15.15,43.18,36.13,50.27v-29.19Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.38,150.74c-2.38-2.38-5.55-3.7-8.92-3.7s-6.54,1.31-8.92,3.7c-4.92,4.92-4.92,12.93,0,17.85l34.16,34.16h-98.08c-6.96,0-12.62,5.66-12.62,12.62s5.66,12.62,12.62,12.62h98.03l-34.45,34.46c-2.38,2.38-3.7,5.55-3.7,8.92s1.31,6.54,3.7,8.92c2.38,2.38,5.55,3.7,8.92,3.7s6.54-1.31,8.92-3.7l56.02-56.02c2.38-2.38,3.7-5.55,3.7-8.92s-1.31-6.54-3.7-8.92l-55.67-55.67Z",
    style: {
      fill: "url(#sign-out-everywhere_svg__ds)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutEverywhere);
export default __webpack_public_path__ + "static/media/sign-out-everywhere.eb664f8a810955d751e7535e369b26da.svg";
export { ForwardRef as ReactComponent };